// src/utils/receipts.js
export const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

/** URD receipt ka URL (inline view ke liye ?pdf=1) */
export const urdReceiptUrl = (id, { inline = true } = {}) => {
  const q = inline ? "pdf=1" : "download=1";
  return `${API_BASE}/urd/${id}/receipt.pdf?${q}`;
};

/** Invoice receipt ka URL (inline view ke liye ?pdf=1) */
export const invoiceReceiptUrl = (id, { inline = true } = {}) => {
  const q = inline ? "pdf=1" : "download=1";
  // NOTE: aapke backend route ke hisaab se plural path use kiya hai
  return `${API_BASE}/invoices/${id}/receipt.pdf?${q}`;
};

/** 🔹 Quotation PDF ka URL */
export const quotationReceiptUrl = (id, { inline = true } = {}) => {
  const q = inline ? "pdf=1" : "download=1";
  // backend route: GET /quotations/:id/quotation.pdf
  return `${API_BASE}/quotations/${id}/quotation.pdf?${q}`;
};

/** 🔹 Estimate PDF ka URL (Invoice/Quotation jaisa hi) */
export const estimateReceiptUrl = (id, { inline = true } = {}) => {
  const q = inline ? "pdf=1" : "download=1";
  // ✅ NOTE: route ko apne backend ke hisaab se set karo
  // common pattern: GET /estimates/:id/receipt.pdf
  return `${API_BASE}/estimates/${id}/receipt.pdf?${q}`;
};

/**
 * New tab me URD PDF open karo (cookie-based auth)
 */
export function openUrdPdfInNewTab(id, { openedTab } = {}) {
  if (!id) return;
  const url = urdReceiptUrl(id, { inline: true });

  if (openedTab && !openedTab.closed) {
    try {
      openedTab.opener = null;
      openedTab.location = url;
      return;
    } catch {
      // ignore
    }
  }

  const tab = window.open(url, "_blank", "noopener,noreferrer");
  if (!tab) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}
/**
 * New tab me INVOICE PDF open karo (cookie-based auth)
 */
export function openInvoicePdfInNewTab(id, { openedTab } = {}) {
  if (!id) return;
  const url = invoiceReceiptUrl(id, { inline: true });

  if (openedTab && !openedTab.closed) {
    try {
      openedTab.opener = null;
      openedTab.location = url;
      return;
    } catch {
      // ignore
    }
  }

  const tab = window.open(url, "_blank", "noopener,noreferrer");
  if (!tab) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}

export function openInvoicePdfInNewWindow(id, { openedWindow } = {}) {
  if (!id) return;

  const url = invoiceReceiptUrl(id, { inline: true });

  // screen ke center me popup window kholne ke liye
  const width = 1000;
  const height = 700;
  const left = window.screenX + Math.max(0, (window.outerWidth - width) / 2);
  const top = window.screenY + Math.max(0, (window.outerHeight - height) / 2);

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    "resizable=yes",
    "scrollbars=yes",
    "toolbar=no",
    "menubar=no",
    "location=no",
    "status=no",
  ].join(",");

  if (openedWindow && !openedWindow.closed) {
    try {
      openedWindow.opener = null;
      openedWindow.location.href = url;
      openedWindow.focus();
      return;
    } catch {
      // ignore
    }
  }

  const popup = window.open(url, "invoicePrintWindow", features);

  if (popup) {
    try {
      popup.opener = null;
      popup.focus();
    } catch {
      // ignore
    }
  } else {
    // popup blocked fallback
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}
/**
 * 🔹 New tab me QUOTATION PDF open karo (URD/Invoice jaisa hi)
 */
export function openQuotationPdfInNewTab(id, { openedTab } = {}) {
  if (!id) return;
  const url = quotationReceiptUrl(id, { inline: true });

  if (openedTab && !openedTab.closed) {
    try {
      openedTab.opener = null;
      openedTab.location = url;
      return;
    } catch {
      // ignore
    }
  }

  const tab = window.open(url, "_blank", "noopener,noreferrer");
  if (!tab) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}

/**
 * 🔹 New tab me ESTIMATE PDF open karo (Invoice/Quotation jaisa hi)
 */
export function openEstimatePdfInNewTab(id, { openedTab } = {}) {
  if (!id) return;
  const url = estimateReceiptUrl(id, { inline: true });

  if (openedTab && !openedTab.closed) {
    try {
      openedTab.opener = null;
      openedTab.location = url;
      return;
    } catch {
      // ignore
    }
  }

  const tab = window.open(url, "_blank", "noopener,noreferrer");
  if (!tab) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}